import React from 'react';
import { useNavigate } from 'react-router-dom';

import styled from '@emotion/styled';

import { Modal } from '../../components/Modal/Modal';
import { TableComponent } from '../../components/TableCom';
import { ModalProvider } from '../../context/ModalContext';
import { TableRefreshProvider } from '../../context/TableRefreshContext';
import CreateWarehouse from '../../sections/dashboard/warehouse/CreateWarehouse';
import CreateWarehouseModal from '../../sections/dashboard/warehouse/CreateWarehouseModal';

const Warehouse = () => {
  const navigate = useNavigate();

  return (
    <TableRefreshProvider>
      <ModalProvider>
        <Container>
          <CreateWarehouse />
          <TableComponent
            tableBaseUrl="warehouse-service/api/v1/warehouses"
            cellNavigation={(data) => {
              navigate(
                `/warehouse/${data.id}/${data.name}/${`lagos`}/${25}/area`
              );
            }}
            tableHeader={[
              'name',
              'warehouseCode',
              'warehouseAddress',
              'rackCount',
              'contactPhoneNo',
            ]}
            mappingData={{
              name: 'Warehouse name',
              warehouseCode: 'Warehouse code',
              warehouseAddress: 'Address',
              rackCount: 'Rack Count',
              contactPhoneNo: 'Contact phone no',
            }}
          />
        </Container>
        <Modal>
          <CreateWarehouseModal />
        </Modal>
      </ModalProvider>
    </TableRefreshProvider>
  );
};

export default Warehouse;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;
